import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Reveal from "@/components/base/Reveal";

const CARDS = [
  {
    to: "/policies/terms",
    icon: "ri-file-text-line",
    title: "Terms of Service",
    text: "The rules of the road for booking, hosting, paying and behaving on Gari.",
  },
  {
    to: "/policies/cancellation",
    icon: "ri-calendar-close-line",
    title: "Cancellation Policy",
    text: "Free-cancellation windows, partial refunds, no-shows and what happens when a host cancels.",
  },
  {
    to: "/policies/insurance",
    icon: "ri-shield-star-line",
    title: "Protection Plans & Insurance",
    text: "Guest protection tiers and host earnings plans, what is covered and how claims work.",
  },
  {
    to: "/policies/guest-standards",
    icon: "ri-user-star-line",
    title: "Guest Standards & Prohibited Uses",
    text: "How to look after a Gari car — cleaning, fuel, smoking, pets and off-limits uses.",
  },
];

export default function PoliciesPage() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />

      <header className="border-b border-background-200/70 bg-background-100">
        <div className="mx-auto w-full max-w-6xl px-4 pb-12 pt-28 md:px-8 md:pb-16 md:pt-40">
          <div className="max-w-3xl">
            <span className="text-sm font-medium uppercase tracking-[0.2em] text-primary-500">Trust &amp; safety</span>
            <h1 className="mt-3 font-heading text-3xl font-semibold text-foreground-950 md:text-4xl">
              Policies &amp; protection
            </h1>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              Everything that keeps a Gari trip fair for both sides — the rules, the refunds, the protection plans and
              the standards we expect from every rider and host in Kenya.
            </p>
          </div>
        </div>
      </header>

      <div className="mx-auto w-full max-w-6xl px-4 pb-20 pt-10 md:px-8 md:pt-14">
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          {CARDS.map((card, index) => (
            <Reveal key={card.to} delay={index * 80}>
              <Link
                to={card.to}
                className="group flex h-full flex-col rounded-2xl surface-card p-6 transition-colors hover:border-primary-500/60"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500/12 text-2xl text-primary-500">
                  <i className={card.icon}></i>
                </span>
                <h2 className="mt-5 font-heading text-lg font-semibold text-foreground-950">{card.title}</h2>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{card.text}</p>
                <span className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-primary-500">
                  Read policy <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                </span>
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-10 grid grid-cols-1 gap-5 rounded-2xl border border-accent-500/30 bg-accent-500/10 p-6 md:grid-cols-3 md:p-8">
            <div className="md:col-span-1">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent-500 text-2xl text-background-50">
                <i className="ri-shield-check-line"></i>
              </span>
              <h2 className="mt-5 font-heading text-xl font-semibold text-foreground-950">Our protection promise</h2>
            </div>
            <div className="md:col-span-2 grid grid-cols-1 gap-5 sm:grid-cols-2">
              {[
                { icon: "ri-secure-payment-line", title: "Payments held safely", text: "M-Pesa payments are verified before a trip starts and released to the host once it completes." },
                { icon: "ri-vidicon-line", title: "Documented handovers", text: "Camera walkaround clips record the car before pickup and after the ride for a fair comparison." },
                { icon: "ri-scales-3-line", title: "Fair dispute handling", text: "Either side can flag damage with a note, and every booking keeps an open dispute until it is resolved." },
                { icon: "ri-customer-service-2-line", title: "24/7 support", text: "Real people in Nairobi on call if a trip does not go to plan." },
              ].map((item) => (
                <div key={item.title} className="rounded-xl bg-background-50 p-4">
                  <p className="flex items-center gap-2 font-heading text-sm font-semibold text-foreground-950">
                    <i className={`${item.icon} text-accent-500`}></i> {item.title}
                  </p>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>

      <Footer />
    </div>
  );
}